// eslint-disable-next-line no-shadow
export enum ReviewerPermissions {
  MANAGE_REVIEWERS = 'admin.coursebuilder.reviewer.manage',
  DELETE_REVIEWERS = 'admin.coursebuilder.reviewers.delete',
  EMAIL_REMIND_REVIEWERS = 'admin.coursebuilder.reviewers.emailreminder',
  STATUS_REVIEW = 'admin.coursebuilder.review.status',
  OUTCOME_COMMENT = 'admin.coursebuilder.reviewer.comment.outcome',
}
